import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import ActionButton from '@/components/misc/ActionButton'
import { useDeleteLinkMutation } from '@/components/misc/ReferralLinksTable/hooks/useDeleteLinkMutation'
import { faTrashAlt } from '@/lib/fontAwesomePro/regular'

interface Props {
  referralLinkId: number
}

const DeleteLinkButton: React.FC<Props> = ({ referralLinkId }) => {
  const deleteLinkMutation = useDeleteLinkMutation()

  return (
    <>
      <ActionButton
        isProcessing={deleteLinkMutation.isPending}
        isProcessingText="Deleting"
        variant="outline-destructive"
        className="flex items-center justify-center gap-2"
        size="sm"
        onClick={() => {
          const hasConfirmedAction = window.confirm(
            'Are you sure you want to delete this link? This action cannot ' +
              'be undone. Any users who have this link will no longer be ' +
              'able to use it.',
          )

          if (hasConfirmedAction) {
            deleteLinkMutation.mutate(referralLinkId)
          }
        }}
      >
        <FontAwesomeIcon icon={faTrashAlt} />
        Delete
      </ActionButton>
    </>
  )
}

export default DeleteLinkButton
